<template>
	<div class="popup-window-wrapper">
		<div class="popup-window" ref="popupWindow">
			<div class="popup-inner">
				<a class="close-img-popup" @click="close">
					<img src="../../../../../public/assets/images/icons/clear-blue.png" />
				</a>
				<div class="popup-left">
					<div class="pop-u-profile">
						<div class="pop-u-profile-image">
							<img src="../../../../../public/assets/images/portraits/rasmus-henriskon.png" />
						</div>
						<div>
							<h3 class="pop-u-profile-name">{{relation.fullName}}</h3>
						</div>
						<div>
							<p class="pop-u-profile-desig">Consultant</p>
						</div>
					</div>
					<div class="popup-profile-desc">
						<div class="ppd-in">
							<p class="ppd-in-name">SAP no</p>
							<p class="ppd-in-val">
								<i>{{relation.sap}}</i>
							</p>
						</div>
						<div class="ppd-in">
							<p class="ppd-in-name">Customer</p>
							<p class="ppd-in-val">
								<i>{{relation.customerName}}</i>
							</p>
						</div>
						<div class="ppd-in">
							<p class="ppd-in-name">Project</p>
							<p class="ppd-in-val">
								<i>{{relation.projectTitle}}</i>
							</p>
						</div>
						<div class="ppd-in">
							<p class="ppd-in-name">Level</p>
							<p class="ppd-in-val">
								<i>{{relation.levels}}</i>
							</p>
						</div>
						<div class="ppd-in">
							<p class="ppd-in-name">Engagement</p>
							<p class="ppd-in-val percent">
								<i>{{relation.projectEngagement}}%</i>
							</p>
						</div>
					</div>
				</div>
				<div class="popup-right">
					<div>
						<p class="popup-heading">New note</p>
					</div>
					<div>
						<p class="popup-date">{{allocation.monthNameAndYear}}</p>
					</div>
					<div class="note-textarea">
						<textarea
							class="note-textarea-text"
							:class="{'error-border':errors.note}"
							@keydown="listenKeyDown"
							v-model="note"
						></textarea>
					</div>
					<div>
						<a @click="saveNote" class="dark-button">Save&close</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: "NotePopUp",
        data: () => {
            return {
                note: null,
                errors: {
                    note: false
                }
            }
        },
        computed: {
            /**
             * Get the note data from stere
             * @returns {default.computed.noteData|(function())|state.noteData|{}}
             */
            noteData: function () {
                return this.$store.state.forecast.noteData;
            },
            /**
             * pick the relation data from the note data
             * @returns {default.computed.relation|(function())|default.computed.relation|relation}
             */
            relation: function () {
                return this.noteData.relation;
            },
            /**
             * Get all allocations from the store
             * @returns {default.computed.allocations|(function())|default.computed.allocations|allocations|default.computed.allocations|default.computed.allocations|*|ReadonlyArray<any>}
             */
            allocations: function () {
                return this.$store.state.forecast.allocations;
            },
            /**
             * Get the current allocation from the index
             * @returns {*}
             */
            allocation: function () {
                let index = this.noteData.allocationIndex;
                return this.allocations[index];
            }
        },
        methods: {
            /**
             * close the popup
             */
            close: function () {
                this.$store.commit("setNotePopUpFlag", false);
            },
            /**
             * save the note and close the popup
             */
            saveNote: function () {
                // if the note is valid
                if (this.validate()) {
                    let monthlyAllocation = _.cloneDeep(this.noteData.monthlyAllocation);
                    // get the monthly allocation from the note data
                    monthlyAllocation.note = this.note;
                    // generate the data to submit
                    let data = {
                        id: this.noteData.index,
                        allocationIndex: this.noteData.allocationIndex,
                        value: monthlyAllocation
                    };
                    // submit the data
                    this.$store.dispatch("updateAllocation", data)
                        .then(
                            response => this.close()
                        )
                }
            },
            /**
             * Validate
             * @returns {boolean}
             */
            validate: function () {
                this.errors.note = false;
                let isValid = true;
                if (!this.note.trim()) {
                    isValid = false;
                    this.errors.note = true;
                }
                return isValid;
            },
            /**
             * If Ctrl+Enter clicked
             * @param e
             */
            listenKeyDown: function (e) {
                if ((e.keyCode === 10 || e.keyCode === 13) && e.ctrlKey) {
                    this.saveNote();
                }
            }
        },
        created() {
            // init the note data
            this.note = this.noteData.monthlyAllocation.note;
        },
        destroyed() {
            // set the note data empty in store
            this.$store.commit("setNotePopUpData", {});
        }
    }
</script>

<style scoped>
	.error-border {
		border: 1px solid red;
	}
</style>
